module.exports = __webpack_public_path__ + "img/logo_maoliang.ea652dd6.png";